// eslint-disable-next-line no-unused-vars
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    gridContainer: {
      padding: theme.spacing(2),
    },
    searchFormControl: {},
    firstTd: {
      borderTopLeftRadius: 16,
    },
    table: {
      '& th:first-child': {
        // borderTopLeftRadius: 16,
      },
      '& th:last-child': {
        borderTopRightRadius: 16,
      },
      '& tr:last-child ': {
        '& td:first-child': { borderBottomLeftRadius: 16 },
        '& td:last-child': { borderBottomRightRadius: 16 },
      },

      '& table': {
        borderRadius: 16,
        marginBottom: 30,
      },
      '& thead': {
        background: '#14171A',
        borderRadius: '16px 16px 0px 0px',
      },
      '& thead th': {
        color: '#fff',
        borderBottom: 'none',
      },
      '& thead tr > *': {
        padding: theme.spacing(1, 2),
      },
      '& tbody tr > *': {
        padding: theme.spacing(0.5, 2),
      },
      '& td': {
        borderBottom: 'none',
      },
      '& tbody tr:nth-of-type(odd) ': {
        background: '#fff',
      },
      '& tbody tr:nth-of-type(even)': {
        background: '#F5F8FA',
      },
    },
    card: {
      display: 'flex',
      background: '#f2f2f2',
      padding: '10px 16px',
      marginBottom: 10,
      borderRadius: 7,
    },
    visuallyHidden: {
      border: 0,
      clip: 'rect(0 0 0 0)',
      height: 1,
      margin: -1,
      overflow: 'hidden',
      padding: 0,
      position: 'absolute',
      top: 20,
      width: 1,
    },
    sortLabel: {
      color: '#fff !important',
    },
    message: {
      margin: theme.spacing(2),
      color: '#14171A',
    },
    classGroup: {
      margin: theme.spacing(0.5),
      marginBottom: 10,
      fontSize: 14,
      fontWeight: 550,
      border: ' 2px dashed #14171A',
      '& span': {
        color: '#14171A',
      },
      color: '#fff',
      cursor: 'pointer',
      '& svg': {
        background: ' #14171A',
        color: '#fff',
      },
    },
    link: {
      textDecoration: 'none',
      color: 'inherit',
      '&:link': {
        color: 'inherit',
      },
      '&:visited': {
        color: 'inherit',
      },
      '&:hover': {
        color: '#0094FF',
      },
      '&:active': {
        color: 'inherit',
      },
    },
  }),
);

export default useStyles;
